import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityFilters } from '@/shared/types/entity';
import { rolesApi } from '../api';
import type { Role, RoleData } from '../types';

export const ROLES_DEFAULT_FILTERS: EntityFilters = { search: '', dateRange: null };

const { actions, reducer } = createEntitySlice<Role, EntityFilters, RoleData>({
  name: 'rolesEntity',
  api: rolesApi,
  initialState: {
    items: [],
    loading: false,
    error: null,
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
    filters: ROLES_DEFAULT_FILTERS,
  },
  getListParams: (state) => ({
    page: state.rolesEntity.currentPage,
    perPage: state.rolesEntity.perPage,
    search: state.rolesEntity.filters.search?.trim() || undefined,
  }),
});

export const {
  fetchItems: fetchRoles,
  createItem: createRole,
  updateItem: updateRole,
  deleteItem: deleteRole,
  setPage,
  setPerPage,
  setFilters,
} = actions;
export { reducer as rolesEntityReducer };
